module.exports = __webpack_public_path__ + "static/media/fire.6365cfcf.svg";